import { applyCtSnapshot } from '@/utils/mappers/applyCtSnapshot';
import { mapProduct } from '@/utils/mappers/map-product';
import { normalizeBrandName } from '@/utils/mappers/normalize-brand-name';
import type { Product as SharedProduct } from '@shared/types/product';
import type { FeaturedProductEntry } from '../types';
import type { CtProductsBySku } from '@/utils/server/getCtSnapshotForSku';

// Brand attribute, re-keyed by the BFF as `variants.attributes.<name>`.
// EWM-327 — normalizeBrandName resolves string / JSON-envelope / empty shapes.
const brandOf = (product: SharedProduct): string | undefined => {
  const attributes = (product.variants?.[0]?.attributes ?? {}) as Record<string, unknown>;
  return normalizeBrandName(attributes['variants.attributes.productBrand']);
};

// EWM-433 — shared entry builder for the Spare Parts / Featured carousels.
// Merges the authoritative Standalone price + stock (ctBySku, resolved +
// cached server-side via getCtSnapshotsForSection) onto each product;
// priceUnavailable / stockUnavailable gate the tile's "Unavailable" surfaces.
export const buildFeaturedEntries = (
  items: SharedProduct[],
  ctBySku: CtProductsBySku,
  mapOptions: Parameters<typeof mapProduct>[1] = {},
): FeaturedProductEntry[] =>
  items.map((product) => {
    const sku = product.variants?.[0]?.sku ?? '';
    const { item, priceUnavailable, stockUnavailable } = applyCtSnapshot(mapProduct(product, mapOptions), ctBySku[sku]);
    return { item, brand: brandOf(product), priceUnavailable, stockUnavailable };
  });
